// extracted by mini-css-extract-plugin
export default {"launcher":"Q_fX","launcher__heading":"Q_fY","launcher__menu-item":"Q_fZ"};